import { isRunningInNativeAndriod } from "@infrastructure/Helpers/IsRunningInNativeApp";
import {
    PostDetailsActionType,
    usePostDetailsModalStore,
} from "../../../Components/Modals/PostDetailsModal/PostDetailsModalStore";
import { publish } from "@infrastructure/Events/EventBus";
import { OPEN_PRESENTER } from "../../../Components/Post/PostForm/events";

export const usePostListEntryClickHandler = () => {
    const { setIsPostDetailsModalOpen, setPostDetailsAction } =
        usePostDetailsModalStore();
    const isRunningInAndroid = isRunningInNativeAndriod();

    return (postId: string, desiredAction?: PostDetailsActionType) => {
        setPostDetailsAction(desiredAction);
        if (
            isRunningInAndroid &&
            window.WebtipAppBridge &&
            WebtipAppBridge.openFeedPresenter
        ) {
            publish({ name: OPEN_PRESENTER });
            WebtipAppBridge.openFeedPresenter(
                "Community",
                `${process.env.REACT_APP_POST_DETAILS_PAGE}?postId=${postId}&action=${desiredAction?.desiredAction}&commentId=${desiredAction?.commentId}`,
                false,
            );
        } else {
            setIsPostDetailsModalOpen(true, postId);
        }
    };
};
